/* tslint:disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { ConnectionsService } from './services/connections.service';
import { SourcesService } from './services/sources.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    ConnectionsService,
    SourcesService,
    ApiConfiguration
  ],
})
export class ConnectionsApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ConnectionsApiModule> {
    return {
      ngModule: ConnectionsApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ConnectionsApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ConnectionsApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
